import * as ACTIONS from "./types"

export const selectCondition = conditionID => ({
  type: ACTIONS.SELECT_CONDITION,
  payload: conditionID
})

export const setStoreName = storeName => ({
  type: ACTIONS.SET_STORENAME,
  payload: storeName
})
